import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useCallback, useEffect, useMemo } from "react";
import {
  planningsByDepartmentAsync,
  selectPlanningsByDayStatus,
  selectTripsByDayStatus,
  tripsByDepartmentAsync,
} from "../../home/fleet/trips/tripsSlice";
import {
  selectAdvancedAnalyticsVehiclesList,
  selectAdvancedAnalyticsVehiclesListStatus,
} from "../../home/fleet/fleetSlice";
import { SharedInterfaceHistory } from "../../home/fleet/history/sharedInterface";
import {
  transactionsListOfADepartmentByPeriodAsync,
  authorizationsRejectedOfADepartmentByPeriodListAsync,
} from "../../home/transactions/transactionsSlice";
import { selectCurrentDepartment } from "../departments/departmentsSlice";
import { TripsAndPlanningsHistory } from "../../home/fleet/trips/tripsApi";
import { HistoryTripsSidePanel } from "../../home/fleet/history/sidePanel/sidePanel";

export const HistoryTab = () => {
  const params = useParams();
  const navigate = useNavigate();
  const firstPath = location.pathname.split("/")[1]; 
  const dispatch = useAppDispatch();
  const advancedAnalyticsVehicleList = useAppSelector(
    selectAdvancedAnalyticsVehiclesList,
  );
  const advancedAnalyticsVehicleListStatus = useAppSelector(
    selectAdvancedAnalyticsVehiclesListStatus,
  );
  const tripsListStatus = useAppSelector(selectTripsByDayStatus);
  const planningsListStatus = useAppSelector(selectPlanningsByDayStatus);
  const department = useAppSelector(selectCurrentDepartment);

  const loadTransactionByPeriodAction = useCallback(
    (payload: { from: string; to: string }) => {
      if (!department) {
        return;
      }
      void dispatch(
        transactionsListOfADepartmentByPeriodAsync({
          departmentUuid: department.uuid,
          from: payload.from,
          to: payload.to,
        }),
      );
    },
    [department, dispatch],
  );

  const loadAuthorizationsRejectedByPeriodAction = useCallback(
    (payload: { from: string; to: string }) => {
      if (!department) {
        return;
      }
      void dispatch(
        authorizationsRejectedOfADepartmentByPeriodListAsync({
          departmentUuid: department.uuid,
          from: payload.from,
          to: payload.to,
        }),
      );
    },
    [department, dispatch],
  );

  useEffect(() => {
    if (
      advancedAnalyticsVehicleList &&
      advancedAnalyticsVehicleList.length > 0 &&
      advancedAnalyticsVehicleListStatus === "success" &&
      department
    ) {
      if (tripsListStatus === "idle")
        void dispatch(
          tripsByDepartmentAsync({
            vehicles: advancedAnalyticsVehicleList,
          }),
        );
      if (planningsListStatus === "idle")
        void dispatch(planningsByDepartmentAsync());
    }
  }, [
    dispatch,
    advancedAnalyticsVehicleListStatus,
    advancedAnalyticsVehicleList,
    tripsListStatus,
    planningsListStatus,
    department,
  ]);

  const hasNoAdvancedAnalyticsVehicles = useMemo(() => {
    return (
      advancedAnalyticsVehicleList.length === 0 &&
      advancedAnalyticsVehicleListStatus === "success"
    );
  }, [advancedAnalyticsVehicleList.length, advancedAnalyticsVehicleListStatus]);

  const sidePanelAction = useCallback(
    (props: { currentTripId: string }) => {
      navigate(`/${firstPath}/fleet/history/${props.currentTripId}`);
    },
    [navigate, firstPath],
  );

  if (params.tab !== "history") {
    return;
  }

  return (
    <SharedInterfaceHistory
      hasNoAdvancedAnalyticsVehicles={hasNoAdvancedAnalyticsVehicles}
      loadTransactionByPeriodAction={loadTransactionByPeriodAction}
      loadAuthorizationsRejectedByPeriodAction={
        loadAuthorizationsRejectedByPeriodAction
      }
      sidePanelAction={sidePanelAction}
      sidePanel={(props: { trip: TripsAndPlanningsHistory; previousTripId: string | null; nextTripId: string | null }) => 
        <HistoryTripsSidePanel 
          tripsAndPlanningsHistory={props.trip}
          previousTripId={props.previousTripId}
          nextTripId={props.nextTripId}
        />
      }
    />
  );
};
